import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { RestService } from 'src/app/services/rest.service';
import { NavController } from '@ionic/angular'
import { ToolsService } from './tools.service';

@Injectable({
  providedIn: 'root'
})

export class NavigationService {
  private history: string[] = []
  private noFollowUrl:any = [
    'license',
    'iframe',
    'send-route',
    'slides',
    'streetmap',
    'custom-route',
    'selfie',
    'register-user'
  ];

  constructor(private router: Router, public rest: RestService, public navCtrl: NavController, public tools: ToolsService) { }

  public startSaveHistory():void{
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const noFollowUrlFound = this.noFollowUrl.some(url => event.urlAfterRedirects.includes(url));
        if (noFollowUrlFound || (this.history.length > 0 && this.history[this.history.length - 1]) == event.urlAfterRedirects) return;
        this.history.push(event.urlAfterRedirects)

        /*
        if (this.history.length == 0){
          this.history.push(event.urlAfterRedirects)
        }else{
          if (!event.urlAfterRedirects.includes('iframe') && this.history[this.history.length-1] != event.urlAfterRedirects){
              this.history.push(event.urlAfterRedirects)
          }
        }
        */
      }
    })
  }

  public getHistory(): string[] {
    return this.history;
  }

  public goBack(): void {
    //this.history = this.history.filter(e => !e.includes('license') && !e.includes('slides'));
    const url = this.history.pop();
    if (this.history.length > 0) {
      //const url = this.history.pop();
      if (this.router.url == url) {
        this.goBack();
        return;
      }

      if ( url == '/home-community'){
        this.rest.setDefaultDeviceSettings();
        this.rest.setDefaultCiceroneData();
        this.rest.ciceroneData.interestPoints = this.tools.sortPointsPerDistance(this.rest.ciceroneData.interestPoints, this.rest.device.location)
        if (this.router.url != '/home'){
          this.router.navigate([url]);
          return;
        }
        this.router.navigateByUrl('/?back=true', { skipLocationChange: true }).then(() => {
          this.tools.setCorporiveColors();
          this.router.navigate([url]);
        });
        return;
      }

      if (url == '/home-kiosk'){
        this.rest.setDefaultDeviceSettings();
        this.rest.setDefaultCiceroneData();
        this.rest.ciceroneData.interestPoints = this.tools.sortPointsPerDistance(this.rest.ciceroneData.interestPoints, this.rest.device.location)
        this.tools.setCorporiveColors();
      }

    
      this.router.navigateByUrl(url)
    } else {
      this.rest.setDefaultDeviceSettings();
      this.rest.setDefaultCiceroneData();
      this.rest.ciceroneData.interestPoints = this.tools.sortPointsPerDistance(this.rest.ciceroneData.interestPoints, this.rest.device.location)
      this.tools.setCorporiveColors();
      this.router.navigateByUrl(this.rest.redirectPage)
    }
  }

}